import { IWorkflow, IWorkflowHandlers } from '@/interfaces/ICalendarWorkflows';
import { notification } from 'antd';

export const createWorkflowHandlers = (
	clientObject: any,
	mutation: any,
	refetch: () => void,
	selectedAgentId: string,
): IWorkflowHandlers => {
	const handleDeleteTextBooking = async (workflowToDelete: IWorkflow) => {
		try {
			const allWorkflows = JSON.parse(clientObject.workflows || '[]');

			const actualIndex = allWorkflows.findIndex((w: any) => w.id === workflowToDelete.id);

			if (actualIndex === -1) {
				notification.error({ message: 'Workflow not found!' });
				return;
			}

			const filteredWorkflows = allWorkflows.filter((_: any, i: number) => i !== actualIndex);

			await mutation.mutateAsync({
				workflows: filteredWorkflows,
				deleteIndex: actualIndex,
				agentId: selectedAgentId,
			});

			notification.success({ message: 'Text booking workflow deleted successfully.' });
			refetch();
		} catch {
			notification.error({ message: 'Something went wrong, please try again later!' });
		}
	};

	const handleDeleteBookingRequest = async (workflowToDelete: IWorkflow) => {
		try {
			let allWorkflows: any[] = [];

			const beginningQuestions = clientObject?.intake_questions
				? JSON.parse(clientObject.intake_questions)
				: [];

			if (beginningQuestions && beginningQuestions.length > 0) {
				allWorkflows.push({
					customScenario: '',
					description: 'beginning',
					questions: beginningQuestions,
					configEnabled: false,
					fallbackMessage: '',
				});
			}

			if (clientObject?.intake_questions_workflows) {
				try {
					const workflowData = JSON.parse(clientObject.intake_questions_workflows) || [];
					allWorkflows = [...allWorkflows, ...workflowData];
				} catch {
					allWorkflows = [...allWorkflows];
				}
			}

			let actualIndex = -1;

			if (workflowToDelete.id) {
				actualIndex = allWorkflows.findIndex((w: any) => w.id === workflowToDelete.id);
			} else {
				actualIndex = allWorkflows.findIndex(
					(w: any) =>
						w.customScenario === workflowToDelete.customScenario &&
						w.bookingRequest === true &&
						JSON.stringify(w.questions) === JSON.stringify(workflowToDelete.questions),
				);
			}

			if (actualIndex === -1) {
				notification.error({ message: 'Workflow not found!' });
				return;
			}

			const filteredWorkflows = allWorkflows.filter((_: any, i: number) => i !== actualIndex);

			const formBuilders = filteredWorkflows.map((scenario: any) => ({
				...scenario,
				description: scenario.customScenario === '' ? 'beginning' : 'custom-scenario',
			}));

			const payload = {
				formBuilders,
				agentId: selectedAgentId,
			};

			await mutation.mutateAsync(payload);

			notification.success({ message: 'Booking request workflow deleted successfully.' });
			refetch();
		} catch {
			notification.error({ message: 'Something went wrong, please try again later!' });
		}
	};

	return {
		handleDeleteTextBooking,
		handleDeleteBookingRequest,
	};
};
